import * as React from "react";
import { forwardRef } from "react";
const SvgStarIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.99999 0.666504L10.4123 5.3463L15.6084 6.19437L11.9031 9.93471L12.7023 15.1386L7.99999 12.7705L3.29771 15.1386L4.09686 9.93471L0.391541 6.19437L5.58772 5.3463L7.99999 0.666504Z" }));
const ForwardRef = forwardRef(SvgStarIcon);
export { ForwardRef as ReactComponent };
